export enum View {
  Grid = 'grid',
  List = 'list',
  Tile = 'tile',
}
